import React, { ChangeEvent, useState } from 'react';

import { MenuItem } from '@material-ui/core';
import { ValidatorForm } from 'react-material-ui-form-validator';

import { CardComponent, PageHeader, PageHeaderNav, TextFieldComponent } from 'components';
import { useServerErrorActions } from 'contexts/ServerErrorContext';
import { api } from 'models/setupApi';

const AVAILABLE_IMAGE_QUALITIES = ['2k', '4k', '8k'];

const CreateTestPlanogram = () => {
  const { handleServerError } = useServerErrorActions();

  const [imagesNumber, setImagesNumber] = useState(10);
  const [imagesQuality, setImagesQuality] = useState('4k');

  const handleSubmit = () => {
    api
      .post('/test_planograms', {
        images_number: imagesNumber,
        images_quality: imagesQuality,
      })
      // eslint-disable-next-line no-console
      .then(data => console.log(data))
      .catch(handleServerError);
  };

  const handleImageNumberChange = (event: ChangeEvent<HTMLInputElement>) => setImagesNumber(Number(event.target.value));

  const handleImageQualityChange = (event: ChangeEvent<HTMLSelectElement>) => setImagesQuality(event.target.value);

  return (
    <ValidatorForm onSubmit={handleSubmit}>
      <PageHeader title="Create Test Planogram">
        <PageHeaderNav withSubmit />
      </PageHeader>
      <CardComponent title="Test Planogram Params" xs={9}>
        <TextFieldComponent
          fullWidth
          label="Images Count (10-3000)"
          value={imagesNumber}
          onChange={handleImageNumberChange}
        />
        <br />
        <br />
        <TextFieldComponent
          fullWidth
          select
          label="Images Quality"
          value={imagesQuality}
          onChange={handleImageQualityChange}
        >
          {AVAILABLE_IMAGE_QUALITIES.map(val => (
            <MenuItem key={val} value={val}>
              {val}
            </MenuItem>
          ))}
        </TextFieldComponent>
      </CardComponent>
    </ValidatorForm>
  );
};

export default CreateTestPlanogram;
